module.exports = "mat-card {\n  width: 400px;\n  height: 200px; }\n\n.replacement-card {\n  margin-left: 70%;\n  margin-right: auto; }\n"